export const sessionStorageInterface = () => {
  const isAuthenticated = () => {
    const auth = sessionStorage.getItem('authenticated')
    return auth === 'true'
  }

  const signIn = (token, user_id, roles) => {
    sessionStorage.setItem('authenticated', 'true')
    sessionStorage.setItem('token', token)
    sessionStorage.setItem('user_id', user_id)
    // Store roles array as JSON string
    sessionStorage.setItem('role', JSON.stringify(roles))
    return true
  }

  const signOut = () => {
    sessionStorage.removeItem('authenticated')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('user_id')
    sessionStorage.removeItem('role')
    return true
  }

  const getToken = () => sessionStorage.getItem('token')

  const getUserId = () => sessionStorage.getItem('user_id')

  const getRole = () => {
    try {
      const roles = sessionStorage.getItem('role')
      return roles ? JSON.parse(roles) : []
    } catch (error) {
      console.error('Error parsing roles from sessionStorage:', error)
      return []
    }
  }

  const loadedData = () => sessionStorage.setItem('last_update', new Date().toISOString())

  return {
    getToken,
    getUserId,
    getRole,
    isAuthenticated,
    loadedData,
    signIn,
    signOut,
  }
}

export default sessionStorageInterface()
